export default {
  id: "admin-org",
  title: "Counselors, Offices & Admin Users",
  section: "Administration",
  order: 92,
  keywords: "counselors offices admin users managed offices billing email USOR deactivate password routing",
  body: `
## What it is

Three small directory pages that the rest of the app leans on. Billing
emails route through **Offices**, authorizations route through
**Counselors**, and permissions/filters route through **Admin users** and
their assignments. Most "why did this send fail?" questions end here.

## Offices

Each office record: name, phones, fax, **Billing Email**, payer, admin, and
address (with autocomplete).

- **Billing Email is load-bearing**: invoice "Send to Office" and other
  office emails go to it. If it's empty, those sends fail with an error.
- Each office row can also generate its **USOR form PDF** directly.

*To add or fix an office*: Offices → add or edit → make sure Billing Email
and address are current → save.

## Counselors

VR counselors: name (required), title, phone, email, and **office**.

The chain matters more than the fields: **authorization → counselor →
office → billing email** is how the app decides where invoices and
authorization-request emails go. When a counselor changes offices, update
the record — stale office assignments send billing to the wrong place.

## Admin users

The Admin page manages admin accounts.

### Step by step: adding an admin

1. Admin → add. Fill first/last name and **email** (required), contact
   info, position ID, and title.
2. Set the initial **password** — at least 8 characters with a number and a
   special character (password fields only appear when creating).
3. Assign **Managed Offices** — this determines which offices' data the
   admin "owns" in scoped views.
4. Save. The account is active immediately.

### Managing existing admins

- **Deactivate** blocks login immediately (the confirmation reminds you);
  reactivate any time. Use it instead of deleting.
- **Change Password** resets an active admin's password.
- Click a row to open the admin's full profile: details, training hours,
  personal compliance documents (driver's license, auto insurance, CPR,
  SOAR, ABI/TBI certification — each Pending/Approved/Expired/Rejected),
  client access, and calendar.

### How assignments drive the app

- Each caregiver/lead has a **managing admin**; each admin has **Managed
  Offices**. Together these power the admin-scoped filters you see on Time
  Off, Verification, and alerts — and decide **who may review whose
  time-off requests**.
- Keep them current when teams change, or people stop seeing (or start
  missing) the right queues.
`,
};
